<div class="modal-container" #component>
    <div class="bg_shadow" (click)="closeM()" [ngClass]="{'iosBg': isIos}"></div>
    <div class="modal" [ngClass]="{'appearUp': enableTransitionUp, 'dissapearDown': (closeProccess && enableTransitionDown)}">
        <div class="modal-header relative">
            <div class="close" [ngClass]="{
                'hidden md:block': stepTitle}" *ngIf="!hideButton" (click)="close()">
                <fun-icon [name]="'x-close'" [style]="'w-32 h-32 stroke-gray-40 stroke-2'"></fun-icon>
            </div>
            <div *ngIf="status" class="modal-status ml-32">
                <label class="label-tag"
                    [ngClass]="{
                        'label-tag-orange': status == 'active' || status == 'pending_acceptation',
                        'label-tag-green': (status == 'won' && offer_status === 'sold') || status == 'sold',
                        'label-tag-red': (status == 'lost' || (status === 'won' && offer_status === 'not_sold')) || status == 'not_sold'}">
                    <span *ngIf="status == 'active' || status == 'pending_acceptation'">{{ 'bid.active-status' | translate }}</span>
                    <span *ngIf="status == 'won' && offer_status !== 'not_sold'">{{ 'bid.won-status' | translate }}</span>
                    <span *ngIf="status === 'won' && offer_status === 'not_sold'">{{ 'bid.expired' | translate }}</span>
                    <span *ngIf="status == 'lost'">{{ 'bid.lost-status' | translate }}</span>
                    <span *ngIf="status == 'sold'">{{ 'offer.sold-status' | translate }}</span>
                    <span *ngIf="status == 'not_sold'">{{ lostTagName }}</span>
                </label>
            </div>
            <div *ngIf="stepTitle" class="md:hidden modal-steps flex min-h-64">
                <div class="flex justify-between items-center w-full">
                    <div class="rounded rounded-full bg-eggplant-100/[0.10] p-4" (click)="close()">
                        <fun-icon [name]="'chevron-left'" [style]="'stroke-[4px] stroke-eggplant-100 w-[24px] h-[24px]'"></fun-icon>
                    </div>
                    <div class="text-xl bg-gradient-2-text">{{ stepTitle }}</div>
                    <div class="text-s text-eggplant-100/[0.40]">{{ stepInfo }}</div>
                </div>
                <div class="absolute bottom-0 w-[calc(100%+40px)] -mx-[15px]">
                    <div class="h-[0.75px] w-full bg-gray-10">
                        <div class="h-2 bg-gradient-2" [ngStyle]="{ width: stepPercent + '%' }" ></div>
                    </div>
                </div>
            </div>
            <div class="line"></div>
        </div>
        <div class="content-modal scrollbar-none flex items-center justify-center" [ngClass]="{'register-content-modal': reduceHeightDefault, 'normal-content-modal': !reduceHeightDefault }" >
            <div #componentPlaceholder></div>
        </div>
    </div>
</div>
